import getItems from './getItems'

export const getItemsPromise = getItems
